'use client'

import { useIsDesktop } from '@repo/ui/hooks'
import { useMemo } from 'react'
import { AccountCTA } from './account/account.cta'
import { FeeCTA } from './fee/fee.cta'
import { MessagesCTA } from './messages/messages.cta'
import { PasswordCTA } from './password/password.cta'
import { SettingsCTA } from './settings/settings.cta'
import { CardsCTA } from './cards/cards.cta'
import { usePathname } from '@repo/shared/i18n/navigation'
export const ProfileHeaderLayout = () => {
  const pathname = usePathname()

  const routeItems = [
    {
      component: <AccountCTA origin='layout' />,
      link: '/profile/account',
    },
    {
      component: <CardsCTA origin='layout' />,
      link: '/profile/cards',
    },
    {
      component: <FeeCTA origin='layout' />,
      link: '/profile/fee',
    },
    {
      component: <SettingsCTA origin='layout' />,
      link: '/profile/settings',
    },
    {
      component: <PasswordCTA />,
      link: '/profile/password',
    },
    {
      component: <MessagesCTA origin='layout' />,
      link: '/profile/messages',
    },
  ]
  const isDesktop = useIsDesktop()
  const activeIndex = useMemo(() => {
    return routeItems.findIndex((route) => pathname?.includes(route.link))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
  return !isDesktop ? routeItems[activeIndex]?.component : undefined
}
